import * as core from '../../../../../../../core'
import * as stakeholderTrainingAudience from '../stakeholder-training-audience'

export const RESOURCE = {
  payload: {
    description: 'Train-the-Trainer / Super User',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderTrainingAudience.RESOURCE.payload.partialId,
    }),
    id: 'Train-the-Trainer / Super User',
    name: 'Train-the-Trainer / Super User',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
